import * as React from 'react'
import { useIsLoggedInQuery, useUserQuery } from 'auth/hooks'
import { usePaymentsDialog } from 'payments/components/payments-dialog-wrapper-context'

import {
  PAYMENT_ENTRY_POINTS,
  savePaymentModalEntryPoint,
} from 'payments/payments-dialog/analytics'
import { sessionStore } from 'utils/storage'

const STORAGE_KEY = 'cfPaymentNudgeShown'

function Nudge() {
  const isNavigatingRef = React.useRef(false)
  const setNavigating = (value: boolean) => {
    isNavigatingRef.current = value // Use a ref instead of state to avoid stale closure issue
  }

  const { open: openPayments } = usePaymentsDialog()
  React.useEffect(() => {
    const timeout = setTimeout(() => {
      if (!sessionStore.getString(STORAGE_KEY) && !isNavigatingRef.current) {
        sessionStore.setString(STORAGE_KEY, 'true')
        savePaymentModalEntryPoint(PAYMENT_ENTRY_POINTS.AUTO_TRIGGERED)
        if (window.cfOpenPaymentsDialog) {
          window.cfOpenPaymentsDialog({ useCase: 'nudge' })
        } else {
          openPayments(undefined, 'nudge')
        }
      }
    }, 5000)

    return () => clearTimeout(timeout)
  }, [openPayments])

  React.useEffect(() => {
    const handleNavigation = () => {
      setNavigating(true)
    }
    window.addEventListener('popstate', handleNavigation)
    window.addEventListener('beforeunload', handleNavigation)

    return () => {
      window.removeEventListener('popstate', handleNavigation)
      window.removeEventListener('beforeunload', handleNavigation)
    }
  }, [])

  return null
}

export function PaymentNudge() {
  const { data: isLoggedIn } = useIsLoggedInQuery()
  const { data: hasAllAccess, isPending } = useUserQuery(undefined, {
    select(data) {
      return data.me?.user?.subscriptionAccess.allAccess.isSubscribed ?? false
    },
  })

  if (isLoggedIn && !isPending && !hasAllAccess) {
    return <Nudge />
  }

  return null
}
